/**
 * Inbox Counter Replacer
 * NOTE: Use carefully, because it does not work if inbox widget is disabled in Org.Settings
 */

define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    var urlUtil = require('util/url.util');
    var BaseReplacerView = require('common/base.replacer.view');
    var inboxApi = require('modules/api/communication.api')('inbox');

    module.exports = BaseReplacerView.extend({
        accessRules: {
            allow: ['user']
        },

        className: 'inbox-counter',

        tagName: 'span',

        subscribe: function() {
            this.listenTo(core, 'inbox:updateCounter', this._updateCounter);
        },

        render: function() {
            var hideInboxByUrl = urlUtil.getLocationParameterByName('hideInbox') === '1';

            if (!hideInboxByUrl) {
                this._updateCounter(inboxApi('getUnreadCount'));
            }

            return this;
        },

        _updateCounter: function(unreadCount) {
            this.$el.toggleClass('has-message', unreadCount > 0);
            this.$el.html(unreadCount || '');
        }
    }, {
        nameOfReplacers: [
            'UNREAD_MESSAGES_COUNT'
        ]
    });
});
